





















import { Pracovnik } from '@/modules/administrace/pracovnik';
import { listFactory } from '@/main/pages';

import { types } from './store/types';
import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				pracovnik: `${this.storeUri}/${types.mutations.ODLOZENA_CINNOST_PRACOVNIK_SELECT_MAPPER}`,
			};
		},
	},
});
